export default "__VITE_ASSET__DnlmihrT__"